import store from "@/state/store";

export default [
    {
        path: "/account/delete",
        name: "Account Delete",
        component: () => import("@/views/account/layout/account-lock.vue"),
        meta: {
            title: "Account Delete",
        },
    },
    {
        path: "/Redirect",
        name: "App Redirect",
        component: () => import("@/General/redirect.vue"),
        meta: {
            title: "App Redirect",
        },
    },
    {
        path: "/obboarding",
        name: "obboarding",
        component: () => import("@/views/account/onboarding.vue"),
        meta: {
            title: "Login",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged inf
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "dashboard"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/",
        name: "login",
        component: () => import("@/views/account/login.vue"),
        meta: {
            title: "Login",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "dashboard"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/send-verification",
        name: "SendVerification",
        component: () => import("@/views/account/send-verification.vue"),
        meta: {
            title: "Register",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/consent-form",
        name: "ConsentForm",
        component: () => import("@/views/account/consent-form.vue"),
        meta: {
            title: "Consent Form",
            authRequired: true
            // beforeResolve(routeTo, routeFrom, next) {
            //     // If the user is already logged in
            //     if (store.getters["auth/loggedIn"]) {
            //         // Redirect to the home page instead
            //         next({ name: "default" });
            //     } else {
            //         // Continue to the login page
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/application-approved",
        name: "ApplicationApproved",
        component: () => import("@/views/account/application-approved.vue"),
        meta: {
            title: "Application Approved",
        },
    },
    {
        path: "/application-rejected",
        name: "ApplicationRejected",
        component: () => import("@/views/account/application-rejected.vue"),
        meta: {
            title: "Application Rejected",
        },
    },
    {
        path: "/otp-list",
        name: "OtpList",
        component: () => import("@/views/account/otp-list.vue"),
        meta: {
            title: "Application Rejected",
        },
    },
    {
        path: "/verification-success",
        name: "VerificationSuccess",
        component: () => import("@/views/account/verification-success.vue"),
        meta: {
            title: "Verification Sucess",
        },
    },
    {
        path: "/admin-setup",
        name: "AdminSetup",
        component: () => import("@/views/account/register/index.vue"),
        meta: {
            title: "Admin Setup",
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("@/views/account/register.vue"),
        meta: {
            title: "Register",
        },
    },
    // {
    //   path: "/admin-details",
    //   name: "Register",
    //   component: () => import("@/views/account/register/childComponents/admin-details"),
    //   meta: {
    //     title: "Register",
    //   },
    // },
    {
        path: "/registration-success",
        name: "RegistrationSuccess",
        component: () => import("@/views/account/registration-success.vue"),
        meta: {
            title: "Registration Success",
        },
    },
    {
        path: "/setup-success",
        name: "ProfileSetupSuccess",
        component: () => import("@/views/account/setup-success.vue"),
        meta: {
            title: "Profile Setup Success",
        },
    },
    {
        path: "/setup-profile",
        name: "ProfileSetup",
        component: () => import("@/views/account/setup-profile/index.vue"),
        meta: {
            title: "Profile Setup",
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Forgot Password",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "dashboard"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/reset-password",
        name: "Reset password",
        component: () => import("@/views/account/reset-password.vue"),
        meta: {
            title: "Reset Password",
        }
    },
    {
        path: "/reset-password-success",
        name: "Reset password success",
        component: () => import("@/views/account/reset-password-success.vue"),
        meta: {
            title: "Reset Password"
        }
    },

    {
        path: "/change-password",
        name: "Change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Change-password",
        },
    },

    //User Management
    {
        path: "/usersManagement/usersList",
        name: "userManagement-usersList",
        meta: {title: "Users List", authRequired: true},
        component: () => import("@/views/menu/usersManagement/users-list.vue"),
    },
    // {
    //   path: "/usersManagement/manageRole",
    //   name: "userManagement-manageRole",
    //   meta: { title: "Manage Role", authRequired: true },
    //   component: () => import("@/views/menu/usersManagement/manage-role.vue"),
    // },
    //Transactions
    {
        path: "/transactions/staffTopupRequests12",
        name: "transactions-staffTopupRequests12",
        meta: {title: "Staff Topup Requests", authRequired: true},
        component: () => import("@/views/menu/transactions/staff-topup-requests.vue"),
    },
    {
        path: "/transactions/staffTopupRequests",
        name: "transactions-staffTopupRequests",
        meta: {title: "Staff Topup Requests", authRequired: true},
        component: () => import("@/views/transaction/staff-topup-request.vue"),
    },
    {
        path: "/transactions/staffExpenses",
        name: "transactions-staffExpenses",
        meta: {title: "Staff Expenses", authRequired: true},
        component: () => import("@/views/transaction/staff-expense.vue"),
    },
    {
        path: "/transactions/all",
        name: "transactions-all",
        meta: {title: "All Transactions", authRequired: true},
        component: () => import("@/views/transaction/all-transaction.vue"),
    },
    {
        path: "/transactions/admin",
        name: "transactions-adminTransactions",
        meta: {title: "Admin Transactions", authRequired: true},
        component: () => import("@/views/transaction/admin-transaction.vue"),
    },
    //Dashboard
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("@/views/menu/dashboard.vue"),
    },
    {
        path: "/confirm",
        name: "fpxConfirmation",
        meta: {
            title: "FPX",
            authRequired: true,
        },
        component: () => import("@/views/manage-account/fpx-confirmation"),
    },
    {
        path: "/manageAccount",
        name: "manage-account",
        meta: {
            title: "Manage Account",
            authRequired: true,
        },
        // component: () => import("@/views/menu/dashboard.vue"),
        component: () => import("@/views/manage-account/index.vue"),

    },

    //Manage Account
    // {
    //     path: "/manageAccount",
    //     name: "manage-account",
    //     meta: {
    //         title: "Manage Account",
    //         authRequired: true,
    //     },
    //    // component: () => import("@/views/menu/dashboard.vue"),
    //      component: () => import("@/views/menu/manage-account.vue"),
    // },
    // {
    //     path: "/manageAccount/topUpMasterAccount",
    //     name: "top-up-master-account",
    //     meta: {
    //         title: "Top Up Master Account",
    //         authRequired: true,
    //     },
    //     component: () => import("@/views/menu-views/manage-account/top-up-master-account.vue"),
    // },
    {
        path: "/manageAccount/topUpMasterAccount",
        name: "top-up-master-account",
        meta: {
            title: "Top Up Master Account",
            authRequired: true,
        },
        component: () => import("@/views/manage-account/topup-master-account.vue"),
    },
    // {
    //     path: "/manageAccount/topUpMasterAccount/onlineTopUp",
    //     name: "online-top-up",
    //     meta: {
    //         title: "Online Top Up",
    //         authRequired: true,
    //     },
    //     component: () => import("@/views/menu-views/manage-account/online-top-up.vue"),
    // },
    //Manage Card
    // {
    //     path: "/cardmanagement",
    //     name: "manage-card",
    //     meta: {
    //         title: "Manage Card",
    //         authRequired: true,
    //     },
    //     component: () => import("@/views/menu/cardManagement/manage-card.vue"),
    // },
    {
        path: "/manageCard",
        name: "cardManagement",
        meta: {
            title: "Manage Card",
            authRequired: true,
        },
        component: () => import("@/views/manage-card/index.vue"),
    },
    {
        path: "/recurringstandinginstruction",
        name: "recurringstandinginstruction",
        meta: {
            title: "Recurring Standing Instruction",
            authRequired: true,
        },
        component: () => import("@/views/manage-card/recurring-tab.vue"),
    },
    {
        path: "/recurringstandinginstruction/:id",
        name: "recurringstandinginstructionview",
        meta: {
            title: "Recurring Standing Instruction",
            authRequired: true,
        },
        component: () => import("@/views/manage-card/viewRecurringApproveDetails.vue"),
    },
    {
        path: "/standinginstruction",
        name: "standinginstruction",
        meta: {
            title: "Standing Instruction",
            authRequired: true,
        },
        component: () => import("@/views/manage-card/standing-instruction.vue"),
    },
    {
        path: "/bulktopup",
        name: "bulktopup",
        meta: {
            title: "Bulk Topup",
            authRequired: true,
        },
        component: () => import("@/views/manage-card/bulktopup.vue"),
    },
//approvebulktopuplist
    {
        path: "/bulktopup/approve",
        name: "approvebulktopup",
        meta: {
            title: "Approve Bulk Topup",
            authRequired: true,
        },
        component: () => import("@/views/bulktopupapprove/index.vue"),
    },

    //Claims folder
    {
        path: "/claims",
        name: "claims",
        meta: {
            title: "Claims",
            authRequired: true,
        },
        component: () => 
            import("@/views/claims/index.vue")
    },
    {
        path: "/claims/claimlist",
        name: "claimslist",
        meta: {
            title: "Claimslist",
            authRequired: true,
        },
        component: () => 
            import("@/views/claims/pendingClaimNew.vue")
    },
    {
        path: "/claims/managereport",
        name: "claimreport",
        meta: {
            title: "claimreport",
            authRequired: true,
        },
        component: () => 
            import("@/views/claims/customizeReport.vue")
    },
    {
        path: "/claims/managereportfield",
        name: "claimreportfield",
        meta: {
            title: "claimreportfield",
            authRequired: true,
        },
        component: () => 
            import("@/views/claims/customReportFields.vue")
    },
    {
        path: "/claims/manageclaimtypefield",
        name: "claimtypefield",
        meta: {
            title: "claimtypefield",
            authRequired: true,
        },
        component: () => 
            import("@/views/claims/claimTypesForm.vue")
    },
    {
        path: "/claims/managesubscription",
        name: "claims-managesubscription",
        meta: {
            title: "Manage Subscription",
            authRequired: true,
        },
        component: () => import("@/views/claims/managesubscription/index.vue"),

    },
    
    ////////////////////////
    {
        path: "/notification",
        name: "Notification",
        meta: {
            title: "Notifiction",
            authRequired: true,
        },
        component: () => import("@/views/notification/index.vue"),
    },
    // {

    //   path: "/claimsmanagement",
    //   name: "claimsmanagement",
    //   meta: {
    //     title: "Claims",
    //     authRequired: true,
    //   },
    //   component: () => import("@/views/menu/claims.vue"),
    // },


    //Notification
    {
        path: "/oldnotification",
        name: "oldNotification",
        meta: {
            title: "Notification",
            authRequired: true,
        },
        component: () => import("@/views/notification/index.vue"),
    },
    {
        path: "/notification",
        name: "Notification",
        meta: {
            title: "Notification",
            authRequired: true,
        },
        component: () => import("@/views/notification/list.vue"),
    },
    //Reports
    {
        path: "/reports",
        name: "reports",
        meta: {
            title: "Reports",
            authRequired: true,
        },
        component: () => import("@/views/menu/reports.vue"),
    },
    {
        path: "/privacy-policy",
        name: "Privacy Policy",
        meta: {
            title: "Privacy Policy",
            authRequired: true,
        },
        component: () => import("@/views/pages/privacy-policy.vue"),
    },
    {
        path: "/product-disclosure",
        name: "Product Disclosure",
        meta: {
            title: "Product Disclosure",
            authRequired: true,
        },
        component: () => import("@/views/pages/product-disclosure.vue"),
    },
    {
        path: "/customer-notice",
        name: "Customer Notice",
        meta: {
            title: "Customer Notice",
            authRequired: true,
        },
        component: () => import("@/views/pages/customer-notice.vue"),
    },
    {
        path: "/terms-condition",
        name: "Terms and Conditions",
        meta: {
            title: "Terms and Condition",
            authRequired: true,
        },
        component: () => import("@/views/pages/terms-and-conditions.vue"),
    },
    //Settings
    {
        path: "/settings",
        name: "settings",
        meta: {
            title: "Settings",
            authRequired: true,
        },
        component: () => import("@/views/settings/index.vue"),
    },
    {
        path: "/settings/general",
        name: "GeneralSettings",
        meta: {
            title: "General",
            authRequired: true,
        },
        component: () => import("@/views/settings/general-settings.vue"),
    },
    //Coming Soon
    // {
    //     path: "/comingsoon",
    //     name: "coming-soon",
    //     meta: {
    //         title: "Coming Soon",
    //         authRequired: true,
    //         },
    //         component: () => import("@/views/coming-soon/index.vue"),
    // },
    {
        path: "/comingsoon/Attendance",
        name: "comingsoon-attendance",
        meta: {
            title: "Attendance",
            authRequired: true,
        },
        component: () => import("@/views/coming-soon/Attendance.vue"),
    },
    {
        path: "/comingsoon/billpayment",
        name: "comingsoon-billpayment",
        meta: {
            title: "Bill payment",
            authRequired: true,
        },
        component: () => import("@/views/coming-soon/Bill-payment.vue"),
    },
    {
        path: "/comingsoon/insurancepurchase",
        name: "comingsoon-Insurancepurchase",
        meta: {
            title: "Insurance purchase",
            authRequired: true,
        },
        component: () => import("@/views/coming-soon/Insurance-purchase.vue"),
    },
    {
        path: "/announcement",
        name: "Announcement",
        meta: {
            title: "Announcement",
            authRequired: true,
        },
        component: () => import("@/views/announcement/index.vue"),
    },
    //user management
    {
        path: "/usermanagement/role",
        name: "ManageAccess",
        meta: {
            title: "ManageAccess",
            authRequired: true,
        },
        component: () => import("@/views/User-Management/manage-access/index.vue"),
    },
    // {
    //   path: "/usermanagement/access",
    //   name: "ManageRole",
    //   meta: {
    //     title: "ManageRole",
    //     authRequired: true,
    //   },
    //   component: () => import("@/views/User-Management/manage-role/index.vue"),
    // },
    {
        path: "/usermanagement/user",
        name: "ManageUser",
        meta: {
            title: "ManageUser",
            authRequired: true,
        },
        component: () => import("@/views/User-Management/manageUser/addUser.vue"),
    },


    // {
    //   path: "/dashboard/crypto",
    //   name: "dashboard-crypto",
    //   meta: {
    //     title: "Crypto",managerole
    //     authRequired: true,
    //   },
    //   component: () => import("@/views/dashboard/crypto/index"),
    // },
    // {
    //   path: "/dashboard/projects",
    //   name: "dashboard-projects",
    //   meta: {
    //     title: "Projects", authRequired: true,
    //   },
    //   component: () => import("@/views/dashboard/projects/index"),
    // },
    // {
    //   path: "/dashboard/crm",
    //   name: "dashboard-crm",
    //   meta: {
    //     title: "CRM", authRequired: true,
    //   },
    //   component: () => import("@/views/dashboard/crm/index"),
    // },
    // {
    //   path: "/dashboard/analytics",
    //   name: "dashboard-analytics",
    //   meta: {
    //     title: "Analytics", authRequired: true,
    //   },
    //   component: () => import("@/views/dashboard/analytics/index"),
    // },
    {
        path: "/logout",
        name: "logout",
        meta: {
            title: "Logout",
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch("auth/logOut");
                } else {
                    store.dispatch("authfack/logout");
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
                    route.push("/")
                );
                // Navigate back to previous page, or home as a fallback
                next(
                    authRequiredOnPreviousRoute ? {name: "dashboard"} : {...routeFrom}
                );
            },
        },
        component: () => import("@/views/auth/logout/basic"),
    },

    // {
    //   path: "/calendar",
    //   name: "calendar",
    //   meta: { title: "Calendar", authRequired: true },
    //   component: () => import("@/views/calendar/index"),
    // },
    // {
    //   path: "/chat",
    //   name: "chat",
    //   meta: { title: "Chat", authRequired: true },
    //   component: () => import("@/views/apps/chat"),
    // },
    // {
    //   path: "/mailbox",
    //   name: "mailbox",
    //   meta: { title: "Mailbox", authRequired: true },
    //   component: () => import("@/views/apps/mailbox"),
    // },
    // {
    //   path: "/apps/projects-list",
    //   name: "projects-list",
    //   meta: { title: "Projects List", authRequired: true },
    //   component: () => import("@/views/apps/projects/list"),
    // },
    // {
    //   path: "/apps/projects-overview",
    //   name: "projects Overview",
    //   meta: { title: "Projects-overview", authRequired: true },
    //   component: () => import("@/views/apps/projects/overview"),
    // },
    // {
    //   path: "/apps/projects-create",
    //   name: "projects-create",
    //   meta: { title: "projects-create", authRequired: true },
    //   component: () => import("@/views/apps/projects/create"),
    // },
    // {
    //   path: "/apps/tasks-details",
    //   name: "tasks-details",
    //   meta: { title: "Tasks Details", authRequired: true },
    //   component: () => import("@/views/apps/tasks/details"),
    // },
    // {
    //   path: "/apps/tasks-kanban",
    //   name: "tasks-kanban",
    //   meta: { title: "Tasks Kanban", authRequired: true },
    //   component: () => import("@/views/apps/tasks/kanban"),
    // },
    // {
    //   path: "/apps/tasks-list-view",
    //   name: "tasks-list-view",
    //   meta: { title: "Taks List", authRequired: true },
    //   component: () => import("@/views/apps/tasks/list-view"),
    // },
    // {
    //   path: "/apps/tickets-details",
    //   name: "tickets-details",
    //   meta: { title: "Ticket Details", authRequired: true },
    //   component: () => import("@/views/tickets/details"),
    // },
    // {
    //   path: "/apps/tickets-list",
    //   name: "tickets-list",
    //   meta: { title: "Tickets List", authRequired: true },
    //   component: () => import("@/views/tickets/list"),
    // },
    // {
    //   path: "/apps/crm-contacts",
    //   name: "crm-contacts",
    //   meta: { title: "CRM Contacts", authRequired: true },
    //   component: () => import("@/views/apps/crm/contacts"),
    // },
    // {
    //   path: "/apps/crm-companies",
    //   name: "crm-companies",
    //   meta: { title: "CRM companies", authRequired: true },
    //   component: () => import("@/views/apps/crm/companies"),
    // },
    // {
    //   path: "/apps/crm-deals",
    //   name: "crm-deals",
    //   meta: { title: "CRM Deals", authRequired: true },
    //   component: () => import("@/views/apps/crm/deals"),
    // },
    // {
    //   path: "/apps/crm-leads",
    //   name: "crm-leads",
    //   meta: { title: "CRM Leads", authRequired: true },
    //   component: () => import("@/views/apps/crm/leads"),
    // },
    // {
    //   path: "/ecommerce/customers",
    //   name: "customers",
    //   meta: { title: "Customers", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/customers"),
    // },
    // {
    //   path: "/ecommerce/products",
    //   name: "products",
    //   meta: { title: "Products", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/products"),
    // },
    // {
    //   path: "/ecommerce/product-details",
    //   name: "product-detail",
    //   meta: { title: "Product Details", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/product-details"),
    // },
    // {
    //   path: "/ecommerce/orders",
    //   name: "orders",
    //   meta: { title: "Orders", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/orders"),
    // },
    // {
    //   path: "/ecommerce/order-details",
    //   name: "order-details",
    //   meta: { title: "Order Details", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/order-details"),
    // },
    // {
    //   path: "/ecommerce/add-product",
    //   name: "add-product",
    //   meta: { title: "Create Product", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/add-product"),
    // },
    // {
    //   path: "/ecommerce/shopping-cart",
    //   name: "shopping cart",
    //   meta: { title: "Shopping Cart", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/shopping-cart"),
    // },
    // {
    //   path: "/ecommerce/checkout",
    //   name: "checkout",
    //   meta: { title: "Check Out", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/checkout"),
    // },
    // {
    //   path: "/ecommerce/sellers",
    //   name: "sellers",
    //   meta: { title: "Sellers", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/sellers"),
    // },
    // {
    //   path: "/ecommerce/seller-details",
    //   name: "seller-details",
    //   meta: { title: "Seller Details", authRequired: true },
    //   component: () => import("@/views/apps/ecommerce/seller-details"),
    // },
    // {
    //   path: "/crypto/buy-sell",
    //   name: "buy/sell",
    //   meta: { title: "Buy & Sell", authRequired: true },
    //   component: () => import("@/views/apps/crypto/buy-sell"),
    // },
    // {
    //   path: "/crypto/kyc",
    //   name: "kyc",
    //   meta: { title: "KYC Application", authRequired: true },
    //   component: () => import("@/views/apps/crypto/kyc"),
    // },
    // {
    //   path: "/crypto/ico",
    //   name: "ico",
    //   meta: { title: "ICO List", authRequired: true },
    //   component: () => import("@/views/apps/crypto/ico"),
    // },
    // {
    //   path: "/crypto/orders",
    //   name: "crypto-orders",
    //   meta: { title: "Orders", authRequired: true },
    //   component: () => import("@/views/apps/crypto/orders"),
    // },
    // {
    //   path: "/crypto/wallet",
    //   name: "wallet",
    //   meta: { title: "My Wallet", authRequired: true },
    //   component: () => import("@/views/apps/crypto/wallet"),
    // },
    // {
    //   path: "/crypto/transactions",
    //   name: "transactions",
    //   meta: { title: "Transactions", authRequired: true },
    //   component: () => import("@/views/apps/crypto/transactions"),
    // },
    // {
    //   path: "/invoices/detail",
    //   name: "invoice-detail",
    //   meta: { title: "Invoice Details", authRequired: true },
    //   component: () => import("@/views/apps/invoices/details"),
    // },
    // {
    //   path: "/invoices/list",
    //   name: "invoice-list",
    //   meta: { title: "Invoice List", authRequired: true },
    //   component: () => import("@/views/apps/invoices/list"),
    // },
    // {
    //   path: "/invoices/create",
    //   name: "invoice-create",
    //   meta: { title: "Create Invoice", authRequired: true },
    //   component: () => import("@/views/apps/invoices/create"),
    // },
    // {
    //   path: "/ui/alerts",
    //   name: "Alerts",
    //   meta: {
    //     title: "Alerts", authRequired: true,
    //   },
    //   component: () => import("@/views/ui/alerts"),
    // },
    // {
    //   path: "/ui/buttons",
    //   name: "Buttons",
    //   meta: {
    //     title: "Buttons", authRequired: true,
    //   },
    //   component: () => import("@/views/ui/buttons"),
    // },
    // {
    //   path: "/ui/cards",
    //   name: "Cards",
    //   meta: { title: "Cards", authRequired: true },
    //   component: () => import("@/views/ui/cards"),
    // },
    // {
    //   path: "/ui/carousel",
    //   name: "Carousel",
    //   meta: { title: "Carousel", authRequired: true },
    //   component: () => import("@/views/ui/carousel"),
    // },
    // {
    //   path: "/ui/dropdowns",
    //   name: "Dropdowns",
    //   meta: { title: "Dropdowns", authRequired: true },
    //   component: () => import("@/views/ui/dropdowns"),
    // },
    // {
    //   path: "/ui/grid",
    //   name: "Grid",
    //   meta: { title: "Grid", authRequired: true },
    //   component: () => import("@/views/ui/grid"),
    // },
    // {
    //   path: "/ui/images",
    //   name: "Images",
    //   meta: { title: "Images", authRequired: true },
    //   component: () => import("@/views/ui/images"),
    // },
    // {
    //   path: "/ui/modals",
    //   name: "Modals",
    //   meta: { title: "Modals", authRequired: true },
    //   component: () => import("@/views/ui/modals"),
    // },
    // {
    //   path: "/ui/offcanvas",
    //   name: "offcanvas",
    //   meta: { title: "Offcanvas", authRequired: true },
    //   component: () => import("@/views/ui/offcanvas"),
    // },
    // {
    //   path: "/ui/progress",
    //   name: "Progress",
    //   meta: { title: "Progress", authRequired: true },
    //   component: () => import("@/views/ui/progress"),
    // },
    // {
    //   path: "/ui/placeholders",
    //   name: "Placeholders",
    //   meta: { title: "Placeholders", authRequired: true },
    //   component: () => import("@/views/ui/placeholders"),
    // },
    // {
    //   path: "/ui/accordions",
    //   name: "accordions",
    //   meta: { title: "Accordions", authRequired: true },
    //   component: () => import("@/views/ui/accordions"),
    // },
    // {
    //   path: "/ui/tabs",
    //   name: "tabs",
    //   meta: { title: "Tabs", authRequired: true },
    //   component: () => import("@/views/ui/tabs"),
    // },
    // {
    //   path: "/ui/typography",
    //   name: "Typography",
    //   meta: { title: "Typography", authRequired: true },
    //   component: () => import("@/views/ui/typography"),
    // },
    // {
    //   path: "/ui/embed-video",
    //   name: "embed-video",
    //   meta: { title: "Embed Video", authRequired: true },
    //   component: () => import("@/views/ui/embed-video"),
    // },
    // {
    //   path: "/ui/ribbons",
    //   name: "ribbons",
    //   meta: { title: "Ribbons", authRequired: true },
    //   component: () => import("@/views/ui/ribbons"),
    // },
    // {
    //   path: "/ui/lists",
    //   name: "lists",
    //   meta: { title: "Lists", authRequired: true },
    //   component: () => import("@/views/ui/lists"),
    // },
    // {
    //   path: "/ui/utilities",
    //   name: "utilities",
    //   meta: { title: "Utilities", authRequired: true },
    //   component: () => import("@/views/ui/utilities"),
    // },
    // {
    //   path: "/ui/notifications",
    //   name: "notifications",
    //   meta: { title: "Notifications", authRequired: true },
    //   component: () => import("@/views/ui/notifications"),
    // },
    // {
    //   path: "/ui/general",
    //   name: "General",
    //   meta: { title: "General", authRequired: true },
    //   component: () => import("@/views/ui/general"),
    // },
    // {
    //   path: "/ui/colors",
    //   name: "Colors",
    //   meta: { title: "Colors", authRequired: true },
    //   component: () => import("@/views/ui/colors"),
    // },
    // {
    //   path: "/ui/badges",
    //   name: "badges",
    //   meta: { title: "Badges", authRequired: true },
    //   component: () => import("@/views/ui/badges"),
    // },
    // {
    //   path: "/ui/media",
    //   name: "media",
    //   meta: { title: "Media", authRequired: true },
    //   component: () => import("@/views/ui/media"),
    // },
    // {
    //   path: "/widgets",
    //   name: "widgets",
    //   meta: { title: "Widgets", authRequired: true },
    //   component: () => import("@/views/widgets/index"),
    // },
    // {
    //   path: "/icons/boxicons",
    //   name: "boxicons-icon",
    //   meta: { title: "Boxicons", authRequired: true },
    //   component: () => import("@/views/icons/boxicons"),
    // },
    // {
    //   path: "/icons/materialdesign",
    //   name: "Material Design",
    //   meta: { title: "material Design", authRequired: true },
    //   component: () => import("@/views/icons/materialdesign"),
    // },
    // {
    //   path: "/icons/feather",
    //   name: "feather",
    //   meta: { title: "Feather", authRequired: true },
    //   component: () => import("@/views/icons/feather"),
    // },
    // {
    //   path: "/icons/lineawesome",
    //   name: "lineawesome",
    //   meta: { title: "Line Awesome", authRequired: true },
    //   component: () => import("@/views/icons/lineawesome"),
    // },
    // {
    //   path: "/icons/remix",
    //   name: "remix",
    //   meta: { title: "Remix", authRequired: true },
    //   component: () => import("@/views/icons/remix"),
    // },
    // {
    //   path: "/tables/basic",
    //   name: "basic-table",
    //   meta: { title: "Basic Table", authRequired: true },
    //   component: () => import("@/views/tables/basic"),
    // },
    // {
    //   path: "/tables/gridjs",
    //   name: "gridjs",
    //   meta: { title: "Grid JS", authRequired: true },
    //   component: () => import("@/views/tables/grid/index"),
    // },
    // {
    //   path: "/form/advanced",
    //   name: "form-advanced",
    //   meta: { title: "Form Advance", authRequired: true },
    //   component: () => import("@/views/forms/advanced"),
    // },
    // {
    //   path: "/form/elements",
    //   name: "form-elements",
    //   meta: { title: "Form Elements", authRequired: true },
    //   component: () => import("@/views/forms/elements"),
    // },
    // {
    //   path: "/form/layouts",
    //   name: "Form Layouts",
    //   meta: { title: "Form Layouts", authRequired: true },
    //   component: () => import("@/views/forms/layouts"),
    // },
    // {
    //   path: "/form/editors",
    //   name: "Form Editors",
    //   meta: { title: "Form Editors", authRequired: true },
    //   component: () => import("@/views/forms/editors"),
    // },
    // {
    //   path: "/form/file-uploads",
    //   name: "File Uploads",
    //   meta: { title: "File Uploads", authRequired: true },
    //   component: () => import("@/views/forms/file-uploads"),
    // },
    // {
    //   path: "/form/validation",
    //   name: "Form Validation",
    //   meta: { title: "Form Validation", authRequired: true },
    //   component: () => import("@/views/forms/validation"),
    // },
    // {
    //   path: "/form/wizard",
    //   name: "Form Wizard",
    //   meta: { title: "Form Wizard", authRequired: true },
    //   component: () => import("@/views/forms/wizard"),
    // },
    // {
    //   path: "/form/masks",
    //   name: "form-mask",
    //   meta: { title: "Form Mask", authRequired: true },
    //   component: () => import("@/views/forms/masks"),
    // },
    // {
    //   path: "/form/pickers",
    //   name: "form-pickers",
    //   meta: { title: "Form Picker", authRequired: true },
    //   component: () => import("@/views/forms/pickers"),
    // },
    // {
    //   path: "/form/range-sliders",
    //   name: "form-range-slider",
    //   meta: { title: "Form Range Slider", authRequired: true },
    //   component: () => import("@/views/forms/range-sliders"),
    // },
    // {
    //   path: "/form/select",
    //   name: "form-select",
    //   meta: { title: "Form Select", authRequired: true },
    //   component: () => import("@/views/forms/select"),
    // },
    // {
    //   path: "/form/checkboxs-radios",
    //   name: "form-checkboxs-radio",
    //   meta: { title: "Checkboxs & Radios", authRequired: true },
    //   component: () => import("@/views/forms/checkboxs-radios"),
    // },
    // {
    //   path: "/pages/starter",
    //   name: "starter",
    //   meta: { title: "Starter", authRequired: true },
    //   component: () => import("@/views/pages/starter"),
    // },
    // {
    //   path: "/pages/profile",
    //   name: "profile",
    //   meta: { title: "Profile", authRequired: true },
    //   component: () => import("@/views/pages/profile/simple"),
    // },
    // {
    //   path: "/pages/profile-setting",
    //   name: "profile-setting",
    //   meta: { title: "Setting", authRequired: true },
    //   component: () => import("@/views/pages/profile/setting"),
    // },
    // {
    //   path: "/pages/maintenance",
    //   name: "maintenance",
    //   meta: { title: "Maintanance", authRequired: true },
    //   component: () => import("@/views/pages/maintenance"),
    // },
    // {
    //   path: "/pages/coming-soon",
    //   name: "coming-soon",
    //   meta: { title: "Comming Soon", authRequired: true },
    //   component: () => import("@/views/pages/coming-soon"),
    // },
    // {
    //   path: "/pages/timeline",
    //   name: "timeline",
    //   meta: { title: "Timeline", authRequired: true },
    //   component: () => import("@/views/pages/timeline"),
    // },
    // {
    //   path: "/pages/faqs",
    //   name: "FAQs",
    //   meta: { title: "FAQs", authRequired: true },
    //   component: () => import("@/views/pages/faqs"),
    // },
    // {
    //   path: "/pages/pricing",
    //   name: "pricing",
    //   meta: { title: "Pricing", authRequired: true },
    //   component: () => import("@/views/pages/pricing"),
    // },
    // {
    //   path: "/pages/team",
    //   name: "team",
    //   meta: { title: "Team", authRequired: true },
    //   component: () => import("@/views/pages/team"),
    // },
    // {
    //   path: "/pages/search-results",
    //   name: "search-results",
    //   meta: { title: "Search Results", authRequired: true },
    //   component: () => import("@/views/pages/search-results"),
    // },
    // {
    //   path: "/pages/sitemap",
    //   name: "sitemap",
    //   meta: { title: "Sitemap", authRequired: true },
    //   component: () => import("@/views/pages/sitemap"),
    // },
    // {
    //   path: "/charts/chartjs",
    //   name: "chartjs-chart",
    //   meta: { title: "Chartjs", authRequired: true },
    //   component: () => import("@/views/charts/chartjs/index"),
    // },
    // {
    //   path: "/charts/echart",
    //   name: "echart",
    //   meta: { title: "Echarts", authRequired: true },
    //   component: () => import("@/views/charts/echart/index"),
    // },
    // {
    //   path: '/charts/apex-line',
    //   name: 'line',
    //   meta: {
    //     title: "Line Charts", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/line/index')
    // },
    // {
    //   path: '/charts/apex-area',
    //   name: 'area-chart',
    //   meta: {
    //     title: "Area Charts", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/area/index')
    // },
    // {
    //   path: '/charts/apex-bar',
    //   name: 'bar-chart',
    //   meta: {
    //     title: "Bar Charts", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/bar/index')
    // },
    // {
    //   path: '/charts/apex-column',
    //   name: 'column-chart',
    //   meta: {
    //     title: "Column Charts", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/column/index')
    // },

    // {
    //   path: '/charts/apex-mixed',
    //   name: 'mixed-chart',
    //   meta: {
    //     title: "Mixed Charts", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/mixed/index')
    // },
    // {
    //   path: '/charts/apex-candlestick',
    //   name: 'candlestick',
    //   meta: {
    //     title: "Candlestick", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/candlestick/index')
    // },
    // {
    //   path: '/charts/apex-boxplot',
    //   name: 'boxplot',
    //   meta: {
    //     title: "Boxplot", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/boxplot/index')
    // },
    // {
    //   path: '/charts/apex-bubble',
    //   name: 'bubble',
    //   meta: {
    //     title: "Bubble Chart", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/bubble/index')
    // },
    // {
    //   path: '/charts/apex-scatter',
    //   name: 'scatter',
    //   meta: {
    //     title: "Scatter", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/scatter/index')
    // },
    // {
    //   path: '/charts/apex-heatmap',
    //   name: 'heatmap',
    //   meta: {
    //     title: "Heatmap", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/heatmap/index')
    // },
    // {
    //   path: '/charts/apex-treemap',
    //   name: 'treemap',
    //   meta: {
    //     title: "Treemap", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/treemap/index')
    // },
    // {
    //   path: '/charts/apex-pie',
    //   name: 'pie',
    //   meta: {
    //     title: "Apex Pie", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/pie/index')
    // },
    // {
    //   path: '/charts/apex-radialbar',
    //   name: 'radialbar',
    //   meta: {
    //     title: "Apex Radialbar", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/radiabar/index')
    // },
    // {
    //   path: '/charts/apex-radar',
    //   name: 'radar',
    //   meta: {
    //     title: "Apex Radar", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/radar/index')
    // },
    // {
    //   path: '/charts/apex-polararea',
    //   name: 'polararea',
    //   meta: {
    //     title: "Polararea", authRequired: true,
    //   },
    //   component: () => import('@/views/charts/apex/polararea/index')
    // },
    // {
    //   path: '/advance-ui/animation',
    //   name: 'animation',
    //   meta: {
    //     title: "Animation", authRequired: true,
    //   },
    //   component: () => import('@/views/advance-ui/animation')
    // },
    // {
    //   path: '/advance-ui/highlight',
    //   name: 'highlight',
    //   meta: {
    //     title: "Highlight", authRequired: true,
    //   },
    //   component: () => import('@/views/advance-ui/highlight')
    // },
    // {
    //   path: '/advance-ui/scrollbar',
    //   name: 'scrollbar',
    //   meta: {
    //     title: "Scrollbar", authRequired: true,
    //   },
    //   component: () => import('@/views/advance-ui/scrollbar')
    // },
    // {
    //   path: '/advance-ui/scrollspy',
    //   name: 'scrollspy',
    //   meta: {
    //     title: "Scrollspy", authRequired: true,
    //   },
    //   component: () => import('@/views/advance-ui/scrollspy')
    // },
    // {
    //   path: '/advance-ui/sweetalerts',
    //   name: 'sweetalerts',
    //   meta: {
    //     title: "Sweet Alerts", authRequired: true,
    //   },
    //   component: () => import('@/views/advance-ui/sweetalerts')
    // },
    // {
    //   path: '/advance-ui/swiper',
    //   name: 'Swiper Slider',
    //   meta: {
    //     title: "Swiper", authRequired: true,
    //   },
    //   component: () => import('@/views/advance-ui/swiper')
    // },
    // {
    //   path: '/auth/signin-basic',
    //   name: 'signin-basic',
    //   meta: {
    //     title: "Signin Basic", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/signin/basic')
    // },
    // {
    //   path: '/auth/signin-cover',
    //   name: 'signin-cover',
    //   meta: {
    //     title: "Signin Cover", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/signin/cover')
    // },
    // {
    //   path: '/auth/signup-basic',
    //   name: 'signup-basic',
    //   meta: {
    //     title: "Signup Basic", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/signup/basic')
    // },
    // {
    //   path: '/auth/signup-cover',
    //   name: 'signup-cover',
    //   meta: {
    //     title: "Signup Cover", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/signup/cover')
    // },
    // {
    //   path: '/auth/reset-pwd-basic',
    //   name: 'reset-pwd-basic',
    //   meta: {
    //     title: "Reset Password", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/reset/basic')
    // },
    // {
    //   path: '/auth/reset-pwd-cover',
    //   name: 'reset-pwd-cover',
    //   meta: {
    //     title: "Reset Password", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/reset/cover')
    // },
    // {
    //   path: '/auth/lockscreen-basic',
    //   name: 'lock-screen-basic',
    //   meta: {
    //     title: "Lock Screen", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/lockscreen/basic')
    // },
    // {
    //   path: '/auth/lockscreen-cover',
    //   name: 'lock-screen-cover',
    //   meta: {
    //     title: "Lock Screen", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/lockscreen/cover')
    // },
    // {
    //   path: '/auth/twostep-basic',
    //   name: 'twostep-basic',
    //   meta: {
    //     title: "Two Step Auth", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/twostep/basic')
    // }, {
    //   path: '/auth/twostep-cover',
    //   name: 'twostep-cover',
    //   meta: {
    //     title: "Two Step Auth", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/twostep/cover')
    // },
    // {
    //   path: '/auth/404',
    //   name: '404',
    //   meta: {
    //     title: "Error 404", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/errors/404')
    // },
    // {
    //   path: '/auth/500',
    //   name: '500',
    //   meta: {
    //     title: "Error 500", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/errors/500')
    // },
    // {
    //   path: '/auth/404-basic',
    //   name: '404-basic',
    //   meta: {
    //     title: "Error 404", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/errors/404-basic')
    // },
    // {
    //   path: '/auth/404-cover',
    //   name: '404-cover',
    //   meta: {
    //     title: "Error 404", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/errors/404-cover')
    // },
    // {
    //   path: '/auth/logout-basic',
    //   name: 'logout-basic',
    //   meta: {
    //     title: "Logout", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/logout/basic')
    // },
    // {
    //   path: '/auth/logout-cover',
    //   name: 'logout-cover',
    //   meta: {
    //     title: "Logout", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/logout/cover')
    // },
    // {
    //   path: '/auth/success-msg-basic',
    //   name: 'success-msg-basic',
    //   meta: {
    //     title: "Success Message", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/success-msg/basic')
    // },
    // {
    //   path: '/auth/success-msg-cover',
    //   name: 'success-msg-cover',
    //   meta: {
    //     title: "Success Message", authRequired: true,
    //   },
    //   component: () => import('@/views/auth/success-msg/cover')
    // },
    // {
    //   path: "/maps/google",
    //   name: "Google Maps",
    //   meta: {
    //     title: "Google Maps", authRequired: true,
    //   },
    //   component: () => import("@/views/maps/google"),
    // },
    // {
    //   path: "/maps/leaflet",
    //   name: "Leaflet Maps",
    //   meta: { title: "Leaflet Maps", authRequired: true },
    //   component: () => import("@/views/maps/leaflet/index"),
    // },
    {
        path: "/microloan",
        name: "microloan",
        meta: {
            title: "microloan",
            authRequired: true,
        },
        component: () => import("@/views/microloan/index.vue"),
    },
    {
        path: "/microloan/add",
        name: "add",
        meta: {
            title: "add",
            authRequired: true,
        },
        component: () => import("@/views/microloan/add"),
    },
    //Report starts
    {
        path: "/report/claim",
        name: "ClaimReport",
        meta: {
          title: "Claim Report",
          authRequired: true,
        },
        component: () => import("@/views/report/claims.vue")
      },
      {
        path: "/report/secondarynumber/detail",
        name: "SecondaryNumberDetailReport",
        meta: {
          title: "Secondary Number Detail Report",
          authRequired: true,
        },
        component: () => import("@/views/report/secondaryno.vue")
      },
      {
        path: "/report/total/transaction",
        name: "TotalTransactionReport",
        meta: {
          title: "Total Transaction Report",
          authRequired: true,
        },
        component: () => import("@/views/report/TotalTransaction.vue")
      },
      {
        path: "/report/total/prefundbalance",
        name: "PrefundStatement",
        meta: {
          title: "Prefund Statement",
          authRequired: true,
        },
        component: () => import("@/views/report/PrefundBalance.vue")
      },
    
      {
        path: "/report/ekyc/registration",
        name: "EKYCRegistrationReport",
        meta: {
          title: "EKYC Registration Report",
          authRequired: true,
        },
        component: () => import("@/views/report/ekycRegistration.vue")
      },
      {
        path: "/report/mfa/transaction",
        name: "MFATransactionReport",
        meta: {
          title: "MFA Transaction Report",
          authRequired: true,
        },
        component: () => import("@/views/report/mfaTransaction.vue")
      },
      {
        path: "/report/mfa/activation",
        name: "MFAActivation Report",
        meta: {
          title: "MFA Activation Report",
          authRequired: true,
        },
        component: () => import("@/views/report/mfaActivation.vue")
      },
      {
        path: "/report/company/OnboardingDetail",
        name: "Company OnBoarding Detail",
        meta: {
          title: "Company OnBoarding Detail",
          authRequired: true,
        },
        component: () => import("@/views/report/companyOnboarding.vue")
      },
      //Report ends

      // estatement
    {
        path: "/estatement/cardholder",
        name: "EStatementCardholder",
        meta: {
            title: "E-statement Report",
            authRequired: true,
        },
        component: () => import("@/views/estatement/cardholder.vue")
    },
    {
        path: "/estatement/corporate",
        name: "EStatementCorporate",
        meta: {
            title: " E-Statement Report",
            authRequired: true,
        },
        component: () => import("@/views/estatement/corporate.vue"),
    },

  //package-subs
   {
        path: "/packagesubs",
        name: "Package Subs",
        meta: {
            title: "Package Subs",
            authRequired: true,
        },
        component: () => import("@/views/account/register/childComponents/package-subs.vue")
    },
    {
        path: "/settings/packagesubscription",
        name: "Package Subs Change",
        meta: {
            title: "Package Subs Change",
            authRequired: true,
        },
        component: () => import("@/views/packageSubsSettings/index.vue")
    },
    {
        path: "/onfido-verification-admin",
        name: "Onfido Verification Admin",
        meta: {
            title: "Onfido Verification Admin",
        },
        component: () => import("@/views/account/register/childComponents/onfido-verification-admin.vue")
    },
    {
        path: "/director/verify",
        name: "Onfido Verification",
        meta: {
            title: "Onfido Verification",
        },
        component: () => import("@/views/account/onfido-verification.vue")
    },
    {
        path: "/howtouse",
        name: "How to Use",
        meta: {
            title: "howtouse",
            authRequired: true,
        },
        component:()=> import ("@/views/howtouse/index.vue")
    },
];
